import moment from 'moment'
import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import { useAuth } from 'src/context/AuthContext'
import { useNewFilterContext } from 'src/context/NewFilterContext/NewFilterContext'

export default function useCustomStartDate() {
  const { currentUser } = useAuth()
  const { moduleDateFilterLoading, moduleDateFilterData, activeModuleEndDate, lastDate } = useNewFilterContext()
  const location = useLocation()

  const { activeRouteDateFilterStart, activeRouteDateFilterEnd } = useMemo(() => {
    let pathname = location?.pathname || ''
    if (pathname.startsWith('/')) {
      pathname = pathname.substring(1)
    }

    const overrides = moduleDateFilterData?.overrides
    if (overrides) {
      const activeRouteDateFilter = overrides.find((item) => item?.route === pathname)
      return {
        activeRouteDateFilterStart: activeRouteDateFilter?.start_date === 'NaT' ? null : activeRouteDateFilter?.start_date,
        activeRouteDateFilterEnd: activeRouteDateFilter?.end_date === 'NaT' ? null : activeRouteDateFilter?.end_date
      }
    }
    return {
      activeRouteDateFilterStart: null,
      activeRouteDateFilterEnd: null
    }
  }, [moduleDateFilterData, location.pathname])

  const customStartDate = useMemo(() => {
    if (activeRouteDateFilterStart) {
      return moment(activeRouteDateFilterStart)
    } else if (currentUser.org === 'whataburger') {
      return moment('2024-07-10')
    } else if (currentUser.org === 'awrg') {
      return moment('2024-07-01')
    }
    return null
  }, [currentUser, activeRouteDateFilterStart])

  const customEndDate = useMemo(() => {
    if (activeRouteDateFilterEnd) {
      return moment(activeRouteDateFilterEnd)
    } else if (activeModuleEndDate) {
      return moment(activeModuleEndDate)
    }
    return null
  }, [activeRouteDateFilterEnd, activeModuleEndDate])

  const moduleLastDate = useMemo(() => {
    if (customEndDate) {
      return customEndDate
    }
    return lastDate
  }, [customEndDate, lastDate])

  return { customStartDate, customEndDate, customDateLoading: moduleDateFilterLoading, moduleLastDate }
}
